import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import styles from './styles.scss';

const ButtonLink = ({
  buttonStyle,
  children,
  className,
  id,
  onClick,
  prefixIcon,
  suffixIcon,
  text,
  type,
}) => (
  <button
    id={id}
    onClick={onClick}
    className={`${styles.link} ${styles[`link-${buttonStyle}`]} ${className}`}
    type={type}
  >
    {prefixIcon && <Icon icon={prefixIcon} round={false} className={styles.prefixIcon} />}
    {text || children}
    {suffixIcon && <Icon icon={suffixIcon} round={false} className={styles.suffixIcon} />}
  </button>
);

ButtonLink.propTypes = {
  buttonStyle: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func,
  prefixIcon: PropTypes.string,
  suffixIcon: PropTypes.string,
  text: PropTypes.node,
  type: PropTypes.string,
};

ButtonLink.defaultProps = {
  buttonStyle: 'primary',
  className: '',
  prefixIcon: '',
  suffixIcon: '',
  text: '',
  type: 'button',
};

export default ButtonLink;
